<template>
    <v-container class="app-page-container">
        <div v-if="getCloseRevision">{{ closeRevision() }}</div>
        <div style="text-align: right;">
            <v-card class="course-additional-activities background-transparent shadow-none">           
                <v-btn class="background-transparent" @click="showStudents()">Student list</v-btn>
            </v-card>
        </div>  

        <div style="text-align: center;">
            <v-icon large @click="prepareNewRevision()">mdi-plus-circle-outline</v-icon>
        </div>
        <RevisionCreateEdit v-if="showNewRevision" :prev_id="0" :prevTitle="revTitle" :prevKey="revKey" :ptimeLimit="timeLimit" :ptaskCount="taskCount"
            :pstartOpen="startOpen" :pendOpen="endOpen" :pmy_date_begin="my_date_begin" :pmy_date_end="my_date_end" :pmy_time_begin="my_time_begin"
            :pmy_time_end="my_time_end" :prev_type="rev_type" :pchapterList="chapterList" :ptask_types="task_types" :pgroupList="groupList"
            />
        <v-card>
            <v-card-title>Revisions</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="2"><b>Title</b></v-col>
                    <v-col cols="1"><b>revKey</b></v-col>
                    <v-col cols="1"><b>Time limit</b></v-col>
                    <v-col cols="1"><b>Tasks</b></v-col>
                    <v-col cols="2"><b>Start</b></v-col>
                    <v-col cols="2"><b>End</b></v-col>
                    <v-col cols="1"><b>Type</b></v-col> 
                </v-row>
                <v-row v-for="(revision,index) in revisionList" :key="index">
                    <v-col cols="2">{{revision.rev_title}}</v-col>
                    <v-col cols="1" @click = "show_key_index = -1" v-if="show_key_index == index" style="cursor:pointer">
                        {{revision.rev_key}}
                    </v-col>
                    <v-col cols="1" @click = "show_key_index = index" v-if="show_key_index != index" style="cursor:pointer">
                        <v-icon>mdi-eye-outline</v-icon>
                    </v-col>
                    <v-col cols="1">{{revision.time_limit}}</v-col>
                    <v-col cols="1">{{revision.task_number}}</v-col>
                    <v-col cols="2">{{revision.open_begin}}</v-col>
                    <v-col cols="2">{{revision.open_end}}</v-col>
                    <v-col cols="1">{{revision.rev_style}}</v-col>
                    <v-col cols="1">
                        <v-icon style="cursor:pointer" @click="prepareEditRevision(index)">edit</v-icon>&nbsp;
                        <v-icon style="cursor:pointer" @click="deleteEditRevision(index)">delete</v-icon></v-col>
                    <v-col cols="12" v-if="index == showEditRevision" :id="'rev'+revision.id">
                        <RevisionCreateEdit :prev_id="rev_id" :prevTitle="revTitle" :prevKey="revKey" :ptimeLimit="timeLimit" :ptaskCount="taskCount"
                        :pstartOpen="startOpen" :pendOpen="endOpen" :pmy_date_begin="my_date_begin" :pmy_date_end="my_date_end" :pmy_time_begin="my_time_begin"
                        :pmy_time_end="my_time_end" :prev_type="rev_type" :pchapterList="chapterList" :ptask_types="task_types" :pgroupList="groupList"
                        />                        
                    </v-col>
                </v-row>

            </v-card-text>
            
        </v-card>
    </v-container>
</template>

<script>
import axios from '../axios-auth'
 import { mapGetters } from 'vuex'
 import RevisionCreateEdit from '../components/revisions/revision_create_edit.vue'
 import GroupList from '../components/data/group_list.vue'
 import * as icn from '../assets/task_icons.js'

export default {
    data() {
        return {
            revisionList: [],
            showNewRevision: false,
            showGroupIndex: -1,
            rev_id: 0,
            revTitle: '',
            revKey: '',
            timeLimit: 0,
            taskCount: 0,
            startOpen: true,
            endOpen: true,
            my_date_begin: '',
            my_date_end: '',
            my_time_begin: '',
            my_time_end: '',
            rev_type: 0,
            chapterList: [],
            task_types: [],
            groupList: [],
            showEditRevision: -1,
            show_key_index: -1
        }
    },
    computed:
        mapGetters([ 'getCloseRevision'
        ])
    ,    
    components: {
        RevisionCreateEdit
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            // all students lessons
            
            this.task_types = icn.getIcons().filter(item => item.type === 'P' || item.type === 'T')
                                 .map(item => ({ ...item, selected: 0 }))

            let _data = {
                course_id: this.$route.params.course_id,
            }
            axios.post('/get-course-revisions', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.chapterList = res.data.chapters
                    this.revisionList = res.data.revisions                    
                    this.groupList = res.data.groups

                    this.groupList = this.groupList.map(item => ({ ...item, selected: 0 }))
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        showStudents() {
            this.$router.push({name:'revisions_teacher', params: {course_id: this.$route.params.id}})
        },
        deleteEditRevision(_index) {
            const _data= {
                course_id: this.$route.params.course_id,
                rev_id: this.revisionList[_index].id
            }
            axios.post('/delete-revision', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    }  else {
                        this.initData()
                    }   
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        prepareNewRevision() {
            this.rev_id = 0
            this.revTitle = ''
            this.revKey = ''
            this.timeLimit = 450
            this.taskCount = 10
            this.startOpen = false
            this.endOpen = false
            this.my_date_begin = new Date().toISOString().slice(0,10)
            this.my_date_end = new Date().toISOString().slice(0,10)
            this.my_time_begin = '00:00'
            this.my_time_end = '00:00'            
            this.rev_type = 0
            for(let i = 0; i < this.chapterList.length; i++) this.chapterList[i].selected = 0
            for(let i = 0; i < this.task_types.length; i++) this.task_types[i].selected = 0
            for(let i = 0; i < this.groupList.length; i++) this.groupList[i].selected = 0
            this.showNewRevision = true
        },
        prepareEditRevision(_index) {
            this.rev_id = this.revisionList[_index].id
            this.revTitle = this.revisionList[_index].rev_title
            this.revKey = this.revisionList[_index].rev_key
            this.timeLimit = this.revisionList[_index].time_limit
            this.taskCount = this.revisionList[_index].task_number
            this.startOpen = this.revisionList[_index].check_OB == 1
            this.endOpen = this.revisionList[_index].check_OE == 1
            this.my_date_begin = this.revisionList[_index].open_begin.substring(0,10)
            this.my_date_end = this.revisionList[_index].open_end.substring(0,10)
            this.my_time_begin = this.revisionList[_index].open_begin.substring(11)          
            this.my_time_end = this.revisionList[_index].open_end.substring(11)          
            this.rev_type = this.revisionList[_index].rev_style

            const _chapters = JSON.parse('['+this.revisionList[_index].chapter_list+']')
            for(let i = 0; i < this.chapterList.length; i++) {
                if (_chapters.indexOf(this.chapterList[i].id) > -1) this.chapterList[i].selected = 1
                else this.chapterList[i].selected = 0
            }

            const _task_types = JSON.parse('['+this.revisionList[_index].question_type_list+']')
            for(let i = 0; i < this.task_types.length; i++) {
                if (_task_types.indexOf(this.task_types[i].id) > -1) this.task_types[i].selected = 1
                else this.task_types[i].selected = 0
            }


            const _sel_groups = this.revisionList[_index].groupList.map(el => el.id);
            for(let i = 0; i < this.groupList.length; i++) {
                if (_sel_groups.indexOf(this.groupList[i].id) >-1) this.groupList[i].selected = 1
                else this.groupList[i].selected = 0
            }
            this.showEditRevision = _index
        },
        closeRevision() {
            this.$store.commit('setCloseRevision',false)
            if (this.showNewRevision) {
                this.showNewRevision = false
                this.initData()
            } 
            if (this.showEditRevision > -1) {
                this.initData()
                const element = document.getElementById('rev'+this.revisionList[this.showEditRevision].id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
                this.showEditRevision = -1
            }
        }
    }
}
</script>